import Service from "../../../Services/index";
const DriverConfigBonus = {
    namespaced: true,
    state: {
        rateBonusDriverLists : [],
        ProvinceDriverLists : [],
    },
    mutations: {
        SET_DRIVER_BONUS_LIST: (state, res) => {
            state.rateBonusDriverLists = res;
        },
        SET_DRIVER_PROVINCE_LIST: (state, res) => {
            state.ProvinceDriverLists = res;
        },
    },
    actions: {
        setDriverBonus({ commit }) {
            return Service.DriverConfigBonus.getBonus()
                .then(data => {
                    commit("SET_DRIVER_BONUS_LIST", data);
                });
        },
        setDriverProvince({ commit }) {
            return Service.DriverConfigBonus.getProvince()
                .then(data => {
                    commit("SET_DRIVER_PROVINCE_LIST", data);
                });
        },
        save({ commit },{id,data}) {
            if(!id){
                return Service.DriverConfigBonus.createBonus(data)
            }
        },
        delete({ commit },id) {
            return Service.DriverConfigBonus.deleteBonus(id);
        },
        saveProvince({ commit },{id,data}) {
            if(!id){
                return Service.DriverConfigBonus.createProvince(data)
            }
        },
        deleteProvince({ commit },id) {
            return Service.DriverConfigBonus.deleteProvince(id);
        },
    }
};
export default DriverConfigBonus;
